import apiRequest from "../../helpers/apiRequest";

export default async (slug, obj) => {
    return await apiRequest({
        method: 'patch',
        url: `content/update/group/session/${slug}/`,
        data: obj
    })
}
